import { getPPFInformation } from './payloadHelper';

function flowPayloadTransformer(payload) {
  return {
    node_position_in_flow: payload.node_id,
    number_of_nodes_in_flow: payload.flow_length,
    node_type: payload.node_type
  };
}

const flowEventsHandler = {
  CHANGE_EVENT: {
    trackerEventName: 'lead_funnel:ppf_node:shown',
    trackerEventVersion: 5,
    getAdditionalInformation: getPPFInformation,
    payloadTransformer: flowPayloadTransformer
  }
};

export default flowEventsHandler;
